import React from 'react';

import Layout from 'common/containers/Layout';
import RewardsTabs from '../components/RewardsTabs';
import RewardsContent from '../components/Rewards';

const OverviewPage = () => (
  <Layout heading="Rewards">
    <RewardsTabs />
    <RewardsContent />
  </Layout>
);

export default OverviewPage;
